import { createRootRoute, Outlet, useRouterState, useNavigate } from '@tanstack/react-router'
import { Sidebar } from '@/components/Sidebar'
import { useAuth } from '@/contexts/AuthContext'
import { useEffect } from 'react'

export const Route = createRootRoute({
  component: RootComponent,
})

function RootComponent() {
  const routerState = useRouterState()
  const navigate = useNavigate()
  const { user, isLoading } = useAuth()
  const currentPath = routerState.location.pathname
  const isAuthPage = currentPath === '/login'

  useEffect(() => {
    if (!isLoading) {
      // Redirect to login if not authenticated and not on auth page
      if (!user && !isAuthPage) {
        navigate({ to: '/login' })
      }
      // Redirect to dashboard if authenticated and on auth page
      if (user && isAuthPage) {
        navigate({ to: '/' })
      }
    }
  }, [user, isLoading, isAuthPage, navigate])

  // Show nothing while checking auth
  if (isLoading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="text-gray-600">Loading...</div>
      </div>
    )
  }

  if (isAuthPage) {
    return <Outlet />
  }

  return (
    <div className="flex h-screen bg-white">
      <Sidebar />
      <main className="flex-1 overflow-auto">
        <Outlet />
      </main>
    </div>
  )
}
